/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Exists/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Exists({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/LocationAction/Location/Exists"
  
}) {
let globalCurrentLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.name',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="global.current_location.name"
 text={globalCurrentLocationNameValueData}
 align="center"
 cursor="pointer"
 size="xmedium"
 marginLeft={dtSpaceXs}
 color={dtColorsNeutral900}
/>
{children}
</React.Fragment>)
}